import Mounter from 'shared/utils/mounter';
import documentReady from 'document-ready';
import TalentMatchingPage from './talent_matching/page';
import AiOptOutPage from './talent_matching/ai_opt_out';

documentReady(() => {
  new Mounter({ TalentMatchingPage, AiOptOutPage }).mountAll();
});
